"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementalBlessingFireEffectHandler = exports.ElementalBlessingFireEffectArgs = void 0;
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
/**
 * @deprecated
 */
class ElementalBlessingFireEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.ElementalBlessingFire;
        this.__typeName = "ElementalBlessingFire";
        this.name = "Elemental Blessing of Fire";
        this.harmful = false;
    }
}
exports.ElementalBlessingFireEffectArgs = ElementalBlessingFireEffectArgs;
let ElementalBlessingFireEffectHandler = class ElementalBlessingFireEffectHandler {
    apply(sequence, container, state) { }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.effectId);
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
ElementalBlessingFireEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.ElementalBlessingFire)
], ElementalBlessingFireEffectHandler);
exports.ElementalBlessingFireEffectHandler = ElementalBlessingFireEffectHandler;
